// @ts-nocheck
/* eslint-disable */
export default class SceneCoords {
	/**
	 * Vytvoreni souradnic nad scenou.
	 *
	 * @class SceneCoords
	 * @param  {Scene} scene Instace sceny
	 * @param  {Number} x Souradnice na ose x
	 * @param  {Number} y Souradnice na ose y
	 */
	constructor(scene, x, y) {
		this._scene = scene;
		this._x = typeof x === "number" ? x : 0;
		this._y = typeof y === "number" ? y : 0;
	}

	/**
	 * Nastaveni x souradnice.
	 *
	 * @param  {Number} value
	 */
	set x(value) {
		this._x = value;
	}

	/**
	 * Nastaveni y souradnice.
	 *
	 * @param  {Number} value
	 */
	set y(value) {
		this._y = value;
	}

	/**
	 * Ziskani souradnice x.
	 *
	 * @return {Number}
	 */
	get x() {
		return this._x;
	}

	/**
	 * Ziskani souradnice y.
	 *
	 * @return {Number}
	 */
	get y() {
		return this._y;
	}

	/**
	 * Prevede souradnice na UTM33, vyuziva scenu pro prevod.
	 *
	 * @return {Array} pole s [x, y]
	 */
	toUTM33() {
		return this._scene.coordsToUTM33(this);
	}

	/**
	 * Prevede souradnice na WGS84, vyuziva scenu pro prevod.
	 *
	 * @param {Number} [format] Formát pro převod na řetězec: čím větší číslo, tím detailnější je řetězec (0 = stupně, 1 = minuty, 2 = vteřiny). Při nezadání bude vrácena dvojice floatů.
	 * @return {Array} pole s [x, y]
	 */
	toWGS84(format?) {
		return this._scene.coordsToWGS84(this, format);
	}

	/**
	 * Prevede souradnice na PP, vyuziva scenu pro prevod.
	 *
	 * @return {Array} pole s [x, y]
	 */
	toPP() {
		return this._scene.coordsToPP(this);
	}

	/**
	 * Prevede souradnice na MERCATOR, vyuziva scenu pro prevod.
	 *
	 * @return {Array} pole s [x, y]
	 */
	toMercator() {
		return this._scene.coordsToMercator(this);
	}

	/**
	 * Prevede souradnice na JTSK, vyuziva scenu pro prevod.
	 *
	 * @return {Array} pole s [x, y]
	 */
	toJTSK() {
		return this._scene.coordsToJTSK(this);
	}

	/**
	 * Prevede souradnice na WGS84, vyuziva scenu pro prevod.
	 *
	 * @param {Number} [codeLength] Formát pro převod na řetězec: čím větší číslo, tím detailnější je řetězec (0 = stupně, 1 = minuty, 2 = vteřiny). Při nezadání bude vrácena dvojice floatů.
	 * @return {Array} pole s [x, y]
	 */
	toOLC(codeLength) {
		return this._scene.coordsToOLC(this, codeLength);
	}

	/**
	 * Převod do MGRS formátu.
	 *
	 * @param  {int} [precision] Přesnost MGRS výstupního hashe; 3: 100 metru, 4: 10 metru, 5: 1 metr
	 * @return {String}
	 */
	toMGRS(precision = 4) {
		return this._scene.coordsToMGRS(this, precision);
	}

	/**
	 * Prevede souradnice na pixel, vyuziva scenu pro prevod a aktivniho providera!
	 *
	 * @param {Number} [zoom] Prevod pro zoom, jinak se pouzije aktualni ze sceny
	 * @return {ScenePixel}
	 */
	toPixel(zoom) {
		return this._scene.coordsToPixel(this, zoom);
	}

	/**
	 * Jsou souradnice totozne?
	 *
	 * @param {SceneCoords} coords Testovaci souradnice
	 * @return {Boolean}
	 */
	equals(coords) {
		return (this._x == coords.x && this._y == coords.y);
	}

	/**
	 * Vytvori kopii souradnic.
	 *
	 * @return {SceneCoords}
	 */
	clone() {
		return new SceneCoords(this._scene, this._x, this._y);
	}

	/**
	 * Spocteni azimutu mezi 2 souradnicemi.
	 *
	 * @param {SceneCoords} coords Porovavaci souradnice
	 * @return {Number} Azimut ve stupnich
	 */
	azimuth(coords) {
		let D2R = Math.PI/180;
		let R2D = 1/D2R;

		let dLon = (coords.x - this._x) * D2R;
		let lat1 = this._y * D2R;
		let lat2 = coords.y * D2R;

		let PI4 = Math.PI/4;
		let dPhi = Math.log(Math.tan(lat2/2+PI4)/Math.tan(lat1/2+PI4));
		if (Math.abs(dLon) > Math.PI) {
			dLon = (dLon>0 ? -(2*Math.PI-dLon) : (2*Math.PI+dLon));
		}

		let az = Math.atan2(dLon, dPhi) * R2D;
		return az.mod(360);
	}

	/**
	 * Spocteni vzdalenosti mezi 2 souradnicemi.
	 *
	 * @param {SceneCoords} coords Porovavaci souradnice
	 * @param {Number} [altitude] Nadmorska vyska
	 * @return {Number} Vzdalenost v [m]
	 */
	distance(coords, altitude?) {
		let alt = 6371009 + (altitude || 0);

		let dx = Math.abs(this._x - coords.x);
		let dy = Math.abs(this._y - coords.y);
		dx = dx * Math.PI/180;
		dy = dy * Math.PI/180;

		let y1 = this._y * Math.PI/180;
		let y2 = coords.y * Math.PI/180;

		let a = Math.sin(dy/2) * Math.sin(dy/2) + Math.cos(y1) * Math.cos(y2) * Math.sin(dx/2) * Math.sin(dx/2);
		let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

		return (alt * c);
	}

	/**
	 * Prevod souradnic na text.
	 *
	 * @return {String}
	 */
	toString() {
		return ("(" + this.x + "," + this.y + ")");
	}

	/**
	 * Prevod souradnic na html format - degrees.
	 *
	 * @return {String}
	 */
	toDeg() {
		let hemisphere = this._getNSEW();

		return (hemisphere.lat + " " + Math.abs(this._y).toFixed(6) + "&deg; " + hemisphere.lon + " " + Math.abs(this._x).toFixed(6) + "&deg;");
	}

	/**
	 * Prevod souradnic na html format - degrees - minutes.
	 *
	 * @return {String}
	 */
	toDegMin() {
		let hemisphere = this._getNSEW();
		let c = this._toDegMin();

		return (hemisphere.lat + " " + c.lat.d + "&deg; " + c.lat.m.toFixed(3) + "&prime; " + hemisphere.lon + " " + c.lon.d + "&deg; " + c.lon.m.toFixed(3) + "&prime;");
	}

	/**
	 * Prevod souradnic na html format - degrees - minutes - seconds.
	 *
	 * @return {String}
	 */
	toDegMinSec() {
		let hemisphere = this._getNSEW();
		let c = this._toDegMinSec();

		return (hemisphere.lat + " " + c.lat.d + "&deg; " + c.lat.m + "&prime; " + c.lat.s.toFixed(3) + "&Prime; " + hemisphere.lon + " " + c.lon.d + "&deg; " + c.lon.m + "&prime; " + c.lon.s.toFixed(3) + "&Prime;");
	}

	/**
	 * Pozice souradnic na zemekouli.
	 *
	 * @private
	 * @return {String}
	 */
	_getNSEW() {
		return {
			lat: this._y >= 0 ? "N" : "S",
			lon: this._x >= 0 ? "E" : "W",
		};
	}

	/**
	 * Prevede aktualni souradnice na degrees - minutes.
	 *
	 * @private
	 * @return {Object}
	 */
	_toDegMin() {
		let d = {
			lat: Math.floor(Math.abs(this._y)),
			lon: Math.floor(Math.abs(this._x))
		};

		let m = {
			lat: (this._y - d.lat) * 60,
			lon: (this._x - d.lon) * 60
		};

		return {
			lat: {
				d: d.lat,
				m: m.lat
			},
			lon: {
				d: d.lon,
				m: m.lon
			}
		};
	}

	/**
	 * Prevede aktualni souradnice na degrees - minutes - seconds.
	 *
	 * @private
	 * @return {Object}
	 */
	_toDegMinSec() {
		let dm = this._toDegMin();

		let s = {
			lat: (dm.lat.m - Math.floor(dm.lat.m)) * 60,
			lon: (dm.lon.m - Math.floor(dm.lon.m)) * 60
		};

		return {
			lat: {
				d: dm.lat.d,
				m: Math.floor(dm.lat.m),
				s: s.lat
			},
			lon: {
				d: dm.lon.d,
				m: Math.floor(dm.lon.m),
				s: s.lon
			}
		};
	}
}
